import { motion } from "framer-motion";
import React, { useRef, useState } from "react";
import VisibilitySensor from "react-visibility-sensor";
import classes from "./TitleSection.module.css";

const TitleHome = ({ text, color }) => {
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef(null);
  const changeVisibility = (isVisibleSensor) => {
    if (isVisibleSensor && isVisible === false) {
      setIsVisible(true);
    }
  };
  return (
    <>
      <div className="mb-5">
        <VisibilitySensor
          onChange={changeVisibility}
          partialVisibility
          delayedCall
        >
          <motion.p
            initial={{ opacity: 0, y: 12 }}
            animate={{
              opacity: isVisible ? 1 : 0,
              y: isVisible ? 1 : 0,
            }}
            transition={{ duration: 0.4, delay: 0.8 }}
            className={
              color === "white"
                ? classes.textCode2White +
                  " fw-600 w-100 mb-0 mt-5"
                : classes.textCode2 +
                  " fw-600 w-100 mb-0 mt-5"
            }
          >
            <span className={
              color === "white"
                ? classes.textCode1White +
                  " fw-600 w-100 mb-0 mt-5"
                : classes.textCode1 +
                  " fw-600 w-100 mb-0 mt-5"
            }>const </span>
            {text}
            <span className={
              color === "white"
                ? classes.textCode1White +
                  " fw-600 w-100 mb-0 mt-5"
                : classes.textCode1 +
                  " fw-600 w-100 mb-0 mt-5"
            }> {`=> {`} </span>
          </motion.p>
        </VisibilitySensor>
      </div>
    </>
  );
};

export default TitleHome;
